import React, { useState, useEffect, useRef } from 'react';
import { Link,} from 'react-router-dom';
//import { Link as LinkScroll } from 'react-scroll';
//import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { getTokenInfo } from '../../../UseToken';
//import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import Main from '../../Main/Init'


//import { List, arrayMove } from "react-movable";;

import {
	reqGET,
	reqPOST,
	//reqDELETE,
	reqPUT,
	reqFILE,
	//repo_banner_link,
	//content_language,
} from '../../../Utils';
import Hosts from '../../../Hosts';

import { language } from './Language';
//import { tr } from 'date-fns/locale';
//import { reduce } from 'core-js/core/array';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const data_mail = {
		id: '',
		info: {
			companycode: getTokenInfo().companycode,
			type: 'message',
			layout: 'normal',
			from: {
				id: getTokenInfo().id, 
				name: getTokenInfo().name 
			},
			course: {
				id: '',
				name: ''
			},
			to: {
				id: '', 
				name: ''
			},
			date: {
				received: '',
				read: '',
				replied: '',
			},
			tags: [],
			status: 'new'
		},
		content: [{
			subject: '',
			message: '',
			attachment: []
		}]
	}

	//const [dados2, set_dados_2] = useState('');

	const [dados_module, set_dados_module] = useState([]);
	const [/*dados_support_material*/, set_dados_support_material] = useState([]);

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);

	const [refresh, setRefresh] = useState(0);
	
	//const [isRedirect, setRedirect] = useState(false);

	//const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)

	//const add_trainers_permission = ('Administrador' === getTokenInfo().profile || 'Gestor de formações' === getTokenInfo().profile || 'Coordenador de formações' === getTokenInfo().profile);

	const [/*editorLoaded*/, setEditorLoaded] = useState(false);

	const [aTypes, ] = useState(['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'])

	const [files_doc, set_files_doc] = useState([]);
	const [files_session_doc, set_files_session_doc] = useState([]);
	const [files_session_evaluation, set_files_session_evaluation] = useState([]);

	const [files_doc_name, set_files_doc_name] = useState([]);
	const [files_session_doc_name, set_files_session_doc_name] = useState([]);

	const [files_evaluation_name, set_files_evaluation_name] = useState([]);
	const [files_session_evaluation_name, set_files_session_evaluation_name] = useState([]);

	const [treeData, setTreeData] = useState([])
	const [treeDataSessions, setTreeDataSessions] = useState([])
	const [treeDataSessionsEvaluation, setTreeDataSessionsEvaluation] = useState([])

	const [inputLink, setInputLink] = useState('') 

    //const [modal_entity_id, set_modal_entity_id] = useState('')
    const [modal_entity_to_name, set_modal_entity_to_name] = useState('')
    //const [modal_entity_from_name, set_modal_entity_from_name] = useState('')
    const [modal_subject, set_modal_subject] = useState('')
    const [modal_message, set_modal_message] = useState('')

    //const [modal_course_id, set_modal_course_id] = useState('')
    const [modal_course_name, set_modal_course_name] = useState('')

    const [a_trainees_send, set_a_trainees_send] = useState([])

	const fetch_id_info = async (id_serch, id_module) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				//console.log(res.data[0])

				res.data[0].content[0].modules.forEach((v2) => {
					// console.log('V3', v3)

					if(v2.id === id_module) {
						set_dados_module(v2);

						if(v2['support_material'] !== undefined) {
							set_dados_support_material(v2['support_material'])
							
							let aux_doc = []
							v2['support_material'].forEach((el, k) => {
								aux_doc.push({ id: (k + 1), id_doc: el.id, title: el.name, link: el.link })
							})
							setTreeData(aux_doc)
							//console.log('aux_doc', aux_doc)
						}

						if(v2.sessions !== undefined) {

							let aux_doc_session = []
							let aux_evaluation_session = []
							v2.sessions.forEach((el_s, k_el_s) => {

								if(el_s['support_material'] !== undefined) {
									el_s['support_material'].forEach((el_s2, k_s2) => {

										if(aux_doc_session[k_el_s] === undefined)
											aux_doc_session[k_el_s] = []

										aux_doc_session[k_el_s].push({ id: (k_s2 + 1), id_doc: el_s2.id, title: el_s2.name, link: el_s2.link })
									})
									setTreeDataSessions(aux_doc_session)
									//console.log('aux_doc_session', aux_doc_session)
								}


								if(el_s['evaluations_material'] !== undefined) {
									//el_s['evaluations_material'][0].forEach((el_s2, k_s2) => {
									el_s['evaluations_material'].forEach((el_s2, k_s2) => {

										if(aux_evaluation_session[k_el_s] === undefined)
											aux_evaluation_session[k_el_s] = []

										aux_evaluation_session[k_el_s].push({ id: (k_s2 + 1), id_doc: el_s2.id, title: el_s2.name, link: el_s2.link })
									})
									setTreeDataSessionsEvaluation(aux_evaluation_session)
									//console.log('aux_evaluation_session', aux_evaluation_session)
								}

							})

						}

					}; 
					//setRefresh(refresh + 1)
					
				})

				return true
			})
			.catch(error => console.log(error))
	}

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}


	useEffect(() => {
		//setEditorLoaded(true);
		clean_data();

		set_lang(localStorage.getItem('lang'))


		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id_formation'], props.location.state.item['id_module'])
					.then((res) => {
						if(res === true) {
							setLoading(false)
							setEditorLoaded(true);
						}

					})

				return
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}
	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info.date.modified.push(today_submit)

					files_doc.forEach(async (el_doc) => {
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, el_doc.number, el_doc.type)
						}
					})

					console.log('files_session_doc', files_session_doc)
					files_session_doc.forEach(async (el_doc) => {
						if (el_doc !== null) {
							await uploadFilesSessionDoc(el_doc.files, el_doc.order, el_doc.index, el_doc.number, el_doc.type)
						}
					})

					files_session_evaluation.forEach(async (el_doc) => {

						console.log('files_session_evaluation', files_session_evaluation)
						if (el_doc !== null) {
							await uploadFilesSessionEvaluation(el_doc.files, el_doc.order, el_doc.index, el_doc.number, el_doc.type)
						}
					})

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 

							set_files_doc([])
							set_files_doc_name([])
							set_files_evaluation_name([])

							//session files
							set_files_session_doc([])
							set_files_session_doc_name([])
							set_files_session_evaluation([])
							set_files_session_evaluation_name([])

							setRefresh(refresh + 1)
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit
					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/formation/course/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									//console.log(res.data)
									dados.current.id = res.data[0].id

									set_is_edit(true)
									//set_show_delete_button(true)
								})
								.catch(() => 404)

							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	/*const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_content_nolang = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.content[0][name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_info_select = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name]['id'] = value)
		set_dados(dados.current.info[name]['name'] = '')
	}*/


	/* MODULE TRAINEES */

	const handle_change_module_trainees = (e) => {
		const { name, value, dataset } = e.target;
		const { index, module_id } = dataset;

		//console.log(index)
		//console.log(module_id)

		set_dados(dados.current.content[0]['modules'][module_id-1]['trainees'][index][name] = value)
		
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current MODULE TRAINEES:' + JSON.stringify(dados))
	}

	const handle_change_module_trainees_evaluations = (e) => {
		const { name, value, dataset } = e.target;
		const { trainee_index, file_index, module_id } = dataset;

		//console.log(index)
		//console.log(module_id)

		set_dados(dados.current.content[0]['modules'][module_id-1]['trainees'][trainee_index]['evaluation_files'][file_index][name] = value)
		
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current MODULE TRAINEES EVALUATIONS:' + JSON.stringify(dados))
	}

	/* MODULES SESSIONS */

	const addMaterialInputLink = (module_id, session_id, name) => {

		//console.log('Id do módulo: ', module_id)
		//console.log('index da sessão: ', session_id)
		//console.log(name)

		
		if(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name] === undefined)
			dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name] = []

		dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name].push(
			{
				link: inputLink
			}
		)

		setInputLink('')

		console.log('Dados Add Link to Sessions:' + JSON.stringify(dados))
	}

	const removeMaterialInputLink = (module_id, session_id, index, name) => {
		
		let del_value = dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name].slice(index, index + 1);

		//console.log('TESTE REMOVE', dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name])
		
		let material_links = dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name].filter(v => v.link !== del_value[0].link);

		set_dados( dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name] = material_links)

		setRefresh(refresh + 1)

	};

	const handle_change_sessions_info = (e) => {
		const { name, value, dataset } = e.target;
		const { module_id, session_id } = dataset;

		console.log('Id do módulo: ', module_id)
		console.log('index da sessão: ', session_id)

		//console.log(value)

		if(name === 'support_material_links' || name === 'evaluations_material_links'){

			setInputLink(value)

			//let aux_links = []
			//let aux_value = value

			//console.log(value)

			/*if(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['support_material_links'] === undefined) {
				dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['support_material_links'] = []
			}*/

			//set_dados(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name] = aux_links)

		 }
		 else{

			set_dados(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id][name] = value)
		 }

		 if(dados.current.content[0].modules[module_id-1]['sessions'][session_id]['uniqid'] !== undefined || dados.current.content[0].modules[module_id-1]['sessions'][session_id]['uniqid'] !== '') {
			let uid = dados.current.content[0].modules[module_id-1]['sessions'][session_id]['uniqid']
			let data = dados.current.content[0].modules[module_id-1]['sessions'][session_id]['data']
			let inicio = dados.current.content[0].modules[module_id-1]['sessions'][session_id]['inicio']
			let fim = dados.current.content[0].modules[module_id-1]['sessions'][session_id]['fim']

			reqGET(`${api_crud_base}/calendar/event/uniqid/${getTokenInfo().companycode}/${uid}`)
				.then(res => {
					let event_aux = res.data[0]

					if(name === 'name') {
						if(dados.current.content[0].modules[module_id-1].name !== '') {
							event_aux.info.title = value
							event_aux.info.body = '<div>' + dados.current.info.name + '</div><div>' + dados.current.content[0].modules[module_id-1].name + '</div>'
						}
						else {
							event_aux.info.title = value
						}
					}
					else if(name === 'data') {
						if(inicio !== '') {
							event_aux.info.start = value + 'T' + inicio + ':00.000Z'
						}
						if(fim !== '') {
							event_aux.info.end = value + 'T' + fim + ':00.000Z'
						}
					}
					else if(name === 'inicio' && data !== '') {
						event_aux.info.start = data + 'T' + value + ':00.000Z'
					}
					else if(name === 'fim' && data !== '') {
						event_aux.info.end = data + 'T' + value + ':00.000Z'
					}
					event_aux.info['id_formation'] = props.location.state.item['id_formation']

					reqPUT(`${api_crud_base}/calendar/event`, event_aux)
					 	.then(() => { })
					 	.catch(() => { })
				})
				.catch(() => { })

		 }

		setRefresh(refresh + 1)
		
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current MODULE SESSIONS:' + JSON.stringify(dados))
	}

	const handle_change_sessions_trainees = (e) => {
		const { name, value, dataset } = e.target;
		const { index, module_id, session_id } = dataset;

		console.log('Id do módulo: ', module_id)
		console.log('index da sessão: ', session_id)
		console.log('index do formando ', index)

		//console.log(value)

		let aux_value = ''

		if(value === 'true') {

			aux_value = true
			
		} else {
			aux_value = false
		}

		set_dados(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['trainees'][index][name] = aux_value)

		setRefresh(refresh + 1)
		
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current MODULE TRAINEES:' + JSON.stringify(dados))
	}

	const handle_change_sessions_select_all_trainees = (e) => {
		const { name, value, dataset } = e.target;
		const { /*index,*/ module_id, session_id } = dataset;

		//console.log('Id do módulo: ', module_id)
		//console.log('index da sessão: ', session_id)
		//console.log('index do formando ', index)

		//console.log(value)

		let aux_value = ''

		if(value === 'true') {

			aux_value = true
			
		} else {
			aux_value = false
		}


		if(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['trainees'] !== undefined && dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['trainees'].length > 0) {

			dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['trainees'].forEach((v) => {
				// console.log(v)

				//v[name] = aux_value
				set_dados(v[name] = aux_value)
				//setRefresh(refresh + 1)
				
			})
		}

		setRefresh(refresh + 1)

		//set_dados(dados.current.content[0]['modules'][module_id-1]['sessions'][session_id]['trainees'][index][name] = aux_value)
		
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current MODULE ALL TRAINEES:' + JSON.stringify(dados))
	}

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { order, type, number } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			let ext = v.name.substring(v.name.lastIndexOf(".") + 1);

			if ((aTypes.includes(ext)) && (v.size < 10485760)) {
				storedFiles.push(v);

				if(type === 'doc') {
					let aux2 = files_doc_name
					aux2.push({ name: v.name, size: v.size })
					set_files_doc_name(aux2)

					let aux_doc = treeData
					let i = treeData.length
					aux_doc.push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
					setTreeData(aux_doc)
				}
				else if(type === 'evaluation') {
					let aux3 = files_evaluation_name
					if(aux3[number] === undefined) {
						aux3[number] = []
					}
					aux3[number] = { name: v.name, size: v.size }
					set_files_evaluation_name(aux3)
				}

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				console.log(language[lang].upload_file_error + v.name);
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		});

		let files_aux = files_doc
		files_aux.push({ files: storedFiles, order: order, number: number, type: type })
		set_files_doc(files_aux)
	}

	const onChangeHandlerSessionsFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { order, type, sessionindex, number } = dataset


		//console.log(dataset)

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			let ext = v.name.substring(v.name.lastIndexOf(".") + 1);

			if ((aTypes.includes(ext)) && (v.size < 10485760)) {
				storedFiles.push(v);

				if(type === 'doc') {

					let aux2 = files_session_doc_name
					aux2.push({ name: v.name, size: v.size })
					set_files_session_doc_name(aux2)

					let aux_doc = treeDataSessions
					//let i = treeDataSessions.length
					//let i = aux_doc[sessionindex].length
					if(aux_doc[sessionindex] === undefined)
						aux_doc[sessionindex] = []

					let i = aux_doc[sessionindex].length

					aux_doc[sessionindex].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
					setTreeDataSessions(aux_doc)

					//console.log(sessionindex)
					//console.log(aux_doc)

				}
				else if(type === 'evaluation') {

					let aux3 = files_session_evaluation_name
					aux3.push({ name: v.name, size: v.size })
					set_files_session_evaluation_name(aux3)

					let aux_doc = treeDataSessionsEvaluation
					//let i = treeDataSessionsEvaluation.length
					
					if(aux_doc[sessionindex] === undefined)
						aux_doc[sessionindex] = []

					let i = aux_doc[sessionindex].length
					aux_doc[sessionindex].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
					setTreeDataSessionsEvaluation(aux_doc)
				}

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				console.log(language[lang].upload_file_error + v.name);
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		});

		if(type === 'doc') {

			let files_aux = files_session_doc
			files_aux.push({ files: storedFiles, order: order, index: sessionindex, number: number, type: type })
			set_files_session_doc(files_aux)
		}

		if(type === 'evaluation') {

			let files_aux_2 = files_session_evaluation
			files_aux_2.push({ files: storedFiles, order: order, index: sessionindex, number: number, type: type })
			set_files_session_evaluation(files_aux_2)
		}
	}

	const uploadFilesDoc = (files, order, number, type) => {
		let aux = []
		files.forEach((element) => {
			//if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, number, type)
					.then(() => {
						//console.log('success')
					})
			//}
			//else {
			//	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			//}
		})
	}

	const uploadFilesSessionDoc = (files, order, index, number, type) => {
		let aux = []
		files.forEach((element) => {
			//if (element.type === "application/pdf") {
				aux.push(element)

				uploadSessionFile(element, order, index, number, type)
					.then(() => {
						//console.log('success')
					})
			//}
			//else {
			//	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			//}
		})
	}

	const uploadFilesSessionEvaluation = (files, order, index, number, type) => {
		let aux = []
		files.forEach((element) => {
			//if (element.type === "application/pdf") {
				aux.push(element)

				uploadSessionFile(element, order, index, number, type)
					.then(() => {
						//console.log('success')
					})
			//}
			//else {
			//	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			//}
		})
	}

	const uploadFile = async (file, order, number, type) => {
		let m_id = props.location.state.item['id_module']

		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', m_id)
		formData.append('formation_id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'module')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/formation' + dados.current.id + '/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				if (type === 'doc') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(el_m.id === m_id) {
							if(dados.current.content[order]['modules'][k_m]['support_material'] === undefined) {
								dados.current.content[order]['modules'][k_m]['support_material'] = []
							}
		
							dados.current.content[order]['modules'][k_m]['support_material'].push({
								id: '',
								link: res.data.path + '/' + res.data.name,
								name: file.name,
								description: '',
								type: type,
								order: order
							})
						}

					})

				}
				else if(type === 'evaluation') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(el_m.id === m_id) {
							if(dados.current.content[order]['modules'][k_m]['evaluations_material'] === undefined) {
								dados.current.content[order]['modules'][k_m]['evaluations_material'] = []
							}
		
							dados.current.content[order]['modules'][k_m]['evaluations_material'][number] = {
								id: '',
								link: res.data.path + '/' + res.data.name,
								name: file.name,
								description: '',
								date: today_file,
								type: type,
								order: order
							}
						}

					})
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const uploadSessionFile = async (file, order, index, number, type) => {
		let m_id = props.location.state.item['id_module']

		const formData = new FormData()
		formData.append('files', file)
		formData.append('module_id', m_id)
		formData.append('session_id', index)
		formData.append('formation_id', dados.current.id)
		formData.append('file_name', file.name)
		//formData.append('type', 'module')
		formData.append('type', 'session')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/formation' + dados.current.id + '/module' + m_id + '');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				if (type === 'doc') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(el_m.id === m_id) {

							el_m['sessions'].forEach((el_s, el_si) => {
								if(parseInt(el_si) === parseInt(index)) {

									if(el_s['support_material'] === undefined) {
										el_s['support_material'] = []
									}
									/*if(el_s['support_material'][index] === undefined) {
										el_s['support_material'][index] = []
									}*/

									//el_s['support_material'][index].push({
									el_s['support_material'].push({
										id: '',
										link: res.data.path + '/' + res.data.name,
										name: file.name,
										description: '',
										type: type,
										order: order
									})

									//console.log('treeDataSessions antes', treeDataSessions[index])

									let aux_material_session = treeDataSessions[index].filter(v => v.link !== undefined)
									let i = aux_material_session.length

									//console.log('aux_material_session antes', aux_material_session)
									//console.log('aux_material_session lenght', i)

									aux_material_session.push({ id: ++i, id_doc: '', title: file.name, link: res.data.path + '/' + res.data.name })

									treeDataSessions[index] = aux_material_session

									//setRefresh(refresh + 1)
									//console.log(treeDataSessions[index])

								}

							})
						}

					})

				}
				else if(type === 'evaluation') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(el_m.id === m_id) {

							

							el_m['sessions'].forEach((el_s, el_si) => {

								if(parseInt(el_si) === parseInt(index)) {


									if(el_s['evaluations_material'] === undefined) {
										el_s['evaluations_material'] = []
									}

									/*if(el_s['evaluations_material'][index] === undefined) {
										el_s['evaluations_material'][index] = []
									}*/

									/*el_s['evaluations_material'][number] = {
										id: '',
										link: res.data.path + '/' + res.data.name,
										name: file.name,
										description: '',
										date: today_file,
										type: type,
										order: order
									}*/

									el_s['evaluations_material'].push({
										id: '',
										link: res.data.path + '/' + res.data.name,
										name: file.name,
										description: '',
										date: today_file,
										type: type,
										order: order
									})

									let aux_evaluation_session = treeDataSessionsEvaluation[index].filter(v => v.link !== undefined)
									let i = aux_evaluation_session.length

									aux_evaluation_session.push({ id: ++i, id_doc: '', title: file.name, link: res.data.path + '/' + res.data.name })

									treeDataSessionsEvaluation[index] = aux_evaluation_session
									//console.log(treeDataSessionsEvaluation[index])

								}

							})
						}

					})
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const handle_change_tree = (tD) => {

		let m_id = props.location.state.item['id_module']

		let aux = []

		tD.forEach((el) => {
			dados.current.content[0].modules.forEach(el_m => {
				if(el_m.id === m_id) {
					if(el_m['support_material']) {
						el_m['support_material'].forEach(el_sm => {

							if(el_sm.link === el.link) {
								aux.push(el_sm)
							}

						})

						//el_m['support_material'] = aux
					}

					//set_dados(dados.current, )
				}
			})
		})
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === m_id) {
				el_m['support_material'] = aux
				set_dados(dados.current, )
			}
		})

		//set_dados(dados.current.content[order].media.doc = aux)
		setTreeData(tD)
		

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_sessions_tree = (tD, index) => {

		let m_id = props.location.state.item['id_module']

		let aux = []

		treeDataSessions[index] = tD
		setRefresh(refresh + 1)

		tD.forEach((el) => {
			dados.current.content[0].modules.forEach(el_m => {
				if(el_m.id === m_id) {

					el_m['sessions'].forEach((el_s, el_si) => {

						if(parseInt(el_si) === parseInt(index)) {
							if(el_s['support_material']) {
								el_s['support_material'].forEach(el_sm => {

									if(el_sm.link === el.link) {
										aux.push(el_sm)
									}

								})

								//el_m['support_material'] = aux
							}
						}

					})
				}
			})
		})
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === m_id) {

				el_m['sessions'].forEach((el_s, el_si) => {

					if(parseInt(el_si) === parseInt(index)) {

						el_s['support_material'] = aux
						set_dados(dados.current, )
					}
				})
			}
		})
		

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_sessions_evaluation_tree = (tD, index) => {

		let m_id = props.location.state.item['id_module']

		let aux = []

		//console.log('index da sessão: ', index)
		//console.log('Tree data: ', tD)

		treeDataSessionsEvaluation[index] = tD
		setRefresh(refresh + 1)

		tD.forEach((el) => {
			dados.current.content[0].modules.forEach(el_m => {
				if(el_m.id === m_id) {

					el_m['sessions'].forEach((el_s, el_si) => {

						if(parseInt(el_si) === parseInt(index)) {
							if(el_s['evaluations_material']) {
								el_s['evaluations_material'].forEach(el_sm => {

									if(el_sm.link === el.link) {
										aux.push(el_sm)
									}

								})

								//el_m['evaluations_material'] = aux
							}
						}

					})
				}
			})
		})

		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === m_id) {

				el_m['sessions'].forEach((el_s, el_si) => {

					if(parseInt(el_si) === parseInt(index)) {

						el_s['evaluations_material'] = aux
						set_dados(dados.current, )
					}
				})
			}
		})

		//setTreeDataSessionsEvaluation(tD)
		

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}


	const remove_element_tree = (order, id, link) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeData.filter(v => v.id !== id)
					setTreeData(treeAux)

					let aux = []
					dados.current.content[0].modules.forEach(el_m => {
						if(el_m.id === props.location.state.item['id_module']) {
							if(el_m['support_material']) {
								el_m['support_material'].forEach(el_sm => {
		
									if(el_sm.link !== link) {
										console.log('xpto1')
										aux.push(el_sm)
									}
									else {
										console.log('xpto2')
									}
		
								})

								//el_m['support_material'] = aux
							}
						}
					})
					console.log('remove', aux)
					dados.current.content[0].modules.forEach(el_m => {
						if(el_m.id === props.location.state.item['id_module']) {
							el_m['support_material'] = aux
							set_dados(dados.current.content[0].modules, )
						}
					})

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_session_tree = (order, id, link, index) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					//let treeAux = treeDataSessions[index].filter(v => v.id !== id)
					//setTreeDataSessions(treeAux)


					let treeAux2 = []

					treeDataSessions[index].forEach(v => {

						if(v.link !== link) {
							treeAux2.push(v)
						}

					})

					//console.log(treeAux2)

					treeDataSessions[index] = treeAux2

					setRefresh(refresh + 1)

					let aux = []
					dados.current.content[0].modules.forEach(el_m => {
						if(el_m.id === props.location.state.item['id_module']) {

							el_m['sessions'].forEach((el_s, el_si) => {

								if(parseInt(el_si) === parseInt(index)) {
									if(el_s['support_material']) {
										el_s['support_material'].forEach(el_sm => {
		
											if(el_sm.link !== link) {
												aux.push(el_sm)
											}
		
										})
		
										//el_m['support_material'] = aux
									}
								}

							})
						}
					})

					//console.log('remove', aux)
					dados.current.content[0].modules.forEach(el_m => {
						if(el_m.id === props.location.state.item['id_module']) {

							el_m['sessions'].forEach((el_s, el_si) => {

								if(parseInt(el_si) === parseInt(index)) {
									el_s['support_material'] = aux
									set_dados(dados.current.content[0].modules, )
								}
							})
						}
					})

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_session_evaluation_tree = (order, id, link, index) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					//let treeAux = treeDataSessionsEvaluation[index].filter(v => v.id !== id)

					//let i = treeAux.length

					/*treeAux.forEach((v, k) => {

						if(k === 0) {
							v.id = 1
						}else{
							v.id = ++k;
						}

					})*/

					//console.log(treeAux)
					//console.log(i)

					//setTreeDataSessionsEvaluation(treeAux)

					//treeDataSessionsEvaluation[index] = treeAux
					//setRefresh(refresh + 1)


					let treeAux2 = []

					treeDataSessionsEvaluation[index].forEach(v => {

						if(v.link !== link) {
							treeAux2.push(v)
						}

					})

					//console.log(treeAux2)

					treeDataSessionsEvaluation[index] = treeAux2

					setRefresh(refresh + 1)
					

					let aux = []
					dados.current.content[0].modules.forEach(el_m => {
						if(el_m.id === props.location.state.item['id_module']) {

							el_m['sessions'].forEach((el_s, el_si) => {

								if(parseInt(el_si) === parseInt(index)) {
									if(el_s['evaluations_material']) {
										el_s['evaluations_material'].forEach(el_sm => {
		
											if(el_sm.link !== link) {
												aux.push(el_sm)
											}
		
										})
		
										//el_m['support_material'] = aux
									}
								}

							})
						}
					})
					//console.log('remove', aux)
					dados.current.content[0].modules.forEach(el_m => {
						if(el_m.id === props.location.state.item['id_module']) {

							el_m['sessions'].forEach((el_s, el_si) => {

								if(parseInt(el_si) === parseInt(index)) {
									el_s['evaluations_material'] = aux
									set_dados(dados.current.content[0].modules, )
								}
							})
						}
					})

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { /*order,*/ id, link, } = dataset

		let auxTree = []

		treeData.forEach((v) => {

			if(v.id === parseInt(id) && v.link === link) {
				v.title = value
			}

			auxTree.push(v)
			
		})

		//treeData = auxTree

		setTreeData(auxTree)

		let aux = []
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === props.location.state.item['id_module']) {
				if(el_m['support_material']) {
					el_m['support_material'].forEach(el_sm => {

						if(el_sm.link === link) {
									
							el_sm.name = value
						}

						aux.push(el_sm)

					})
				}
			}
		})
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === props.location.state.item['id_module']) {
				el_m['support_material'] = aux
				set_dados(dados.current.content[0].modules, )
			}
		})
	}

	const edit_element_sessions_tree = (e) => {
		const { value, dataset } = e.target;
		const { /*order,*/ id, link, index } = dataset

		//console.log(value)
		//console.log(dataset)
		//console.log(id)
		//console.log(link)
		//console.log(sessionindex)

		let auxTree = []

		treeDataSessions[index].forEach((v) => {

			if(v.id === parseInt(id) && v.link === link) {
				v.title = value
			}

			auxTree.push(v)

			
		})

		//console.log(auxTree)

		treeDataSessions[index] = auxTree

		let aux = []
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === props.location.state.item['id_module']) {

				el_m['sessions'].forEach((el_s, el_si) => {

					if(parseInt(el_si) === parseInt(index)) {
						if(el_s['support_material']) {
							el_s['support_material'].forEach(el_sm => {

								if(el_sm.link === link) {
									
									el_sm.name = value
								}

								aux.push(el_sm)

							})

							//el_m['support_material'] = aux
						}
					}

				})
			}
		})
		//console.log('remove', aux)
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === props.location.state.item['id_module']) {

				el_m['sessions'].forEach((el_s, el_si) => {

					if(parseInt(el_si) === parseInt(index)) {
						el_s['support_material'] = aux
						set_dados(dados.current.content[0].modules, )
					}
				})
			}
		})
	}

	const edit_element_sessions_evaluation_tree = (e) => {
		const { value, dataset } = e.target;
		const { /*order,*/ id, link, index } = dataset

		//console.log(value)
		//console.log(dataset)
		//console.log(id)
		//console.log(link)
		//console.log(sessionindex)

		let auxTree = []

		treeDataSessionsEvaluation[index].forEach((v) => {

			if(v.id === parseInt(id) && v.link === link) {
				v.title = value
			}

			auxTree.push(v)

			
		})

		//console.log(auxTree)

		treeDataSessionsEvaluation[index] = auxTree

		let aux = []
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === props.location.state.item['id_module']) {

				el_m['sessions'].forEach((el_s, el_si) => {

					if(parseInt(el_si) === parseInt(index)) {
						if(el_s['evaluations_material']) {
							el_s['evaluations_material'].forEach(el_sm => {

								if(el_sm.link === link) {

									el_sm.name = value
								}

								aux.push(el_sm)

							})

							//el_m['support_material'] = aux
						}
					}

				})
			}
		})
		//console.log('remove', aux)
		dados.current.content[0].modules.forEach(el_m => {
			if(el_m.id === props.location.state.item['id_module']) {

				el_m['sessions'].forEach((el_s, el_si) => {

					if(parseInt(el_si) === parseInt(index)) {
						el_s['evaluations_material'] = aux
						set_dados(dados.current.content[0].modules, )
					}
				})
			}
		})

	}

	const open_link = (link) => {
		window.open(link, '_blank'); 
	}

	const handle_change_send_trainees = (e) => {
		const { value, dataset } = e.target;
		const { traineeid, traineename } = dataset;

		let x = a_trainees_send
		if(value === 'true') {
			x.push({id: traineeid, name: traineename})
		}
		else {
			x = x.filter((e) => e.id !== traineeid)
		}
		set_a_trainees_send(x)
		setRefresh(refresh + 1)

	}

	const sendMessageModal = (course_name, module_name) => {

		set_modal_course_name(course_name + ': ' + module_name)

		let x = ''
		a_trainees_send.forEach((el) => {
			x = x + el.name + '; '
		})
		set_modal_entity_to_name(x)

        set_modal_subject('')
        set_modal_message('')

    }

    const handleSendMessage = () => {
        var today = new Date()

        if(modal_subject === '') {
            Swal.fire(language[lang].send_error + ' ' + language[lang].send_error_subject, '', 'info')
            return
        }

        if(modal_message === '') {
            Swal.fire(language[lang].send_error + ' ' + language[lang].send_error_message, '', 'info')
            return
        }

        Swal.fire({
            title: language[lang].send_title,
            text: language[lang].send_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].send_confirm,
            cancelButtonText: language[lang].send_cancel
        })
        .then((result) => {
            if(result.isConfirmed) {

				a_trainees_send.forEach((el) => {

					data_mail.info.to.id = el.id
					data_mail.info.to.name = el.name

					data_mail.info.date.received = today

					data_mail.info.course.name = modal_course_name

					data_mail.content[0].subject = modal_subject
					data_mail.content[0].message = modal_message

					reqPOST(`${api_crud_base}/app/messages`, data_mail)
						.then(() => { 
							// Swal.fire(language[lang].send_success, '', 'info')
							// setRefresh(refresh + 1)
						})
						.catch(() => Swal.fire(language[lang].send_error, '', 'info'))
			
				})
            }
        })

        // console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
    }

	return isloading ?
		
		<Loader />
		
		:

		<main id="module_gest">
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].gest}</h2>
					<span>
						<Link to={{ pathname: endpoints.list }}  >
							{language[lang].content}
						</Link>
						&nbsp;&#47;&nbsp;
						{language[lang].content_gest}
					</span>
				</div>

				{/*console.log('DADOS FORMAÇÃO & MÓDULOS: ', dados.current)*/}
				{/*console.log('DADOS MÓDULO: ', dados_module)*/}
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row mb-5">

							<div className='col-12 border-bottom'>
								<h3 className="fw-bolder">{language[lang].formation}</h3>
							</div>
							<div className='col-12 mt-3'>
								<h4 className='fw-bold'>{dados.current.content[0].title}</h4>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].date_begin}&#58;&nbsp;
								</label>
								<span>
									{dados.current.info.date.begin.split('T')[0]}
								</span>
							</div>


							<div className='col-12 mt-3'>
								<button
									//className="btn btn-link"
									className="btn btn-secondary"
									type="button" 
									alt={language[lang].send_title}
									title={language[lang].send_title}
									data-bs-toggle="offcanvas" 
									data-bs-target={"#offcanvasAttendanceListMessage"}
									aria-controls={"offcanvasAttendanceListMessage"}
									>
										{/*language[lang].attendance_view*/}
										{language[lang].send_title}
										<i className="bi bi-send text-white ms-2"></i>
								</button>
							</div>

						</div>
						<div className="row mb-5">

							<div className='col-12 border-bottom'>
								<h3 className="fw-bolder">{language[lang].module}</h3>
							</div>
							<div className='col-12 mt-3'>
								<h4 className='fw-bold'>{dados_module.name}</h4>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].sessions_number}&#58;&nbsp;
								</label>
								<span>
									{dados_module.sessions_number}
								</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].evaluations_number}&#58;&nbsp;
								</label>
								<span>
									{dados_module.evaluations_number}
								</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].duration}&#58;&nbsp;
								</label>
								<span>
									{dados_module.duration}
								</span>
							</div>

							{
								dados_module.trainer !== undefined && dados_module.trainer.name !== '' ? (
									<div className='col-12 mt-3'>
										<label className='fw-bold'>
											{language[lang].trainer}&#58;&nbsp;
										</label>
										<span>
											{dados_module.trainer.name}
										</span>
									</div>
								) : null 
							}

							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].attendance_record}&#58;&nbsp;
								</label>
								<button
									className="action ms-2"
									type="button" 
									alt={language[lang].attendance_record}
									title={language[lang].attendance_record}
									data-bs-toggle="modal"
									data-bs-target={"#moduleAttendanceListModal"}
									>
										<i className="bi bi-people fs-3"></i>
										<span className="tooltiptext">{language[lang].attendance_record}</span>
								</button>
								<div className={"modal bg-light fade"} id={"moduleAttendanceListModal"} tabIndex="-1" aria-labelledby={"moduleAttendanceListModalLabel"} aria-hidden="true" >
									<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title" id={"moduleAttendanceListModalLabel"}>
													{dados_module.name}
												</h5>
												<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
											</div>
											<div className="modal-body">
												<div className="col-12">
													<label className="col-form-label fw-bold">
														{language[lang].attendance_record}
													</label>
												</div>
												<div className="col-12 mb-4">
													<label className="col-form-label fw-bold d-block">
														{language[lang].attendance_record_label}
													</label>
													<span className='d-inline-flex align-items-center'>
														<i className={"bi bi-check fs-3 text-success"} alt={language[lang].attendance_record_present} title={language[lang].attendance_record_present}></i>
														&nbsp;
														{language[lang].attendance_record_present}
													</span>
													<span className='d-inline-flex align-items-center'>
														<i className={"bi bi-x fs-3 text-danger"} alt={language[lang].attendance_record_missed} title={language[lang].attendance_record_missed}></i>
														&nbsp;
														{language[lang].attendance_record_missed}
													</span>
													<span className='d-flex align-items-center'>
														<i className={"bi bi-calendar-x fs-3"} alt={language[lang].attendance_record_soon} title={language[lang].attendance_record_soon}></i>
														&nbsp;
														{language[lang].attendance_record_soon}
													</span>
												</div>
												<div className="col-12 table-responsive">
													<table className="table table-striped table-hover table-bordered align-middle">
														<thead>
															<tr>
																<th className="fs-6 fw-bold">{language[lang].trainee}</th>
																{ 
																	dados_module.sessions !== undefined && dados_module.sessions.length > 0 ? (
																			
																		dados_module.sessions.map( ( elem2 , index2 ) => {

																			//console.log('sessões: ', elem2)
																			
																			if(elem2.name === '')
																				return ''
																			else
																				return(
																					
																					<th key = {`${index2}`} className="fs-6 fw-bold">
																						{elem2.name}
																					</th>
																					
																				)
																		})											
																			
																	) : <th className='fw-bold'>{language[lang].sessions_empty}</th>
																}
															</tr>
														</thead>
														{ 
															dados_module.sessions !== undefined && dados_module.sessions.length > 0 ? (
																	
																dados_module.sessions.map( ( elem3 , index3 ) => {

																	if(index3 === 0) 

																	return(
																		
																		<tbody key = {`${index3}`}>
																			{ 
																				elem3.trainees !== undefined && elem3.trainees.length > 0 ? (
																					elem3.trainees.map( ( v , index4 ) => {
																							
																						if(v.trainee_id === '')
																							return ''
																						else
																							return(

																								<tr key = {`${index4}`}>
																									<td>
																										<label className="col-form-label fs-6">{v.trainee_name}</label>
																									</td>

																									{
																										dados_module.sessions.map( ( elem4 , index5 ) => {

																											//console.log('sessão', elem4)
																											let today = new Date().toJSON()

																											return (
																												<td key = {`${index5}`}>

																													{ 
																														elem4.trainees !== undefined && elem4.trainees.length > 0 ? (
																															elem4.trainees.map( ( v2 , index6 ) => {

																																let aux_trainee_session_attendance = ''
																																let trainee_session_attendance_icon = ''

																																if(v2.trainee_session_attendance !== undefined && v2.trainee_session_attendance !== '' && v2.trainee_session_attendance === true){
																																	aux_trainee_session_attendance = language[lang].attendance_record_present
																																	trainee_session_attendance_icon = 'check fs-3 text-success'

																																}else if (v2.trainee_session_attendance !== undefined && v2.trainee_session_attendance !== '' && v2.trainee_session_attendance === false && (today > elem4.data)){
																																	aux_trainee_session_attendance = language[lang].attendance_record_missed
																																	trainee_session_attendance_icon = 'x fs-3 text-danger'
																																}
																																else {
																																	aux_trainee_session_attendance = language[lang].attendance_record_soon
																																	trainee_session_attendance_icon = 'calendar-x fs-3'
																																}

																																if(v2.trainee_id === v.trainee_id)
																																	return (
																																		<i key = {`${index6}`} className={"bi bi-" + trainee_session_attendance_icon} alt={aux_trainee_session_attendance} title={aux_trainee_session_attendance}></i>
																																	)
																																else return null
																															})
																														) : <span className='fw-bold'>{language[lang].trainees_empty}</span>
																													}
																												</td>

																											)
																										})
																									}

																								</tr>

																							)
																					})
																				) : <tr>
																						<td>
																							<span className='fw-bold'>{language[lang].trainees_empty}</span>
																						</td>
																					</tr>
																			}
																		</tbody>
																		
																	)
																	else return null
																	
																})											
																	
															) : null /*<span className='fw-bold'>{language[lang].sessions_empty}</span>*/
														}
													</table>
												</div>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].module_evaluations}&#58;&nbsp;
								</label>
								<button
									className="action ms-3"
									type="button" 
									alt={language[lang].module_evaluations}
									title={language[lang].module_evaluations}
									data-bs-toggle="modal"
									data-bs-target={"#moduleTraineesEvaluationModal"}
									>
										<i className="bi bi-table fs-3"></i>
										<span className="tooltiptext d-none" style={{left: 'unset', right: 10}}>{language[lang].module_evaluations}</span>
								</button>
								<div className={"modal bg-light fade"} id={"moduleTraineesEvaluationModal"} tabIndex="-1" aria-labelledby={"moduleTraineesEvaluationModalLabel"} aria-hidden="true" >
									<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title" id={"moduleTraineesEvaluationModalLabel"}>
													{dados.current.content[0].title}
												</h5>
												<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
											</div>
											<div className="modal-body">
												<div className="col-12">
													<label className="col-form-label fw-bold">
														{language[lang].module_evaluations}
													</label>
												</div>
												<div className="col-12 mb-4">
													<label className="col-form-label fw-bold d-block">
														{language[lang].attendance_record_label}
													</label>
													<span className='d-flex align-items-center'>
														<i className={"bi bi-clipboard-x fs-3"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>
														&nbsp;
														{language[lang].module_evaluations_soon}
													</span>
												</div>
												<div className="col-12 table-responsive">
													<table className="table table-striped table-hover table-bordered align-middle">
														<thead>
															<tr>
																<th className="fs-6 fw-bold">{language[lang].trainee}</th>
																<th className="fs-6 fw-bold">{language[lang].module_evaluation}</th>
															</tr>
														</thead>
																		
														<tbody >
															{ 
																dados_module.trainees !== undefined && dados_module.trainees.length > 0 ? (
																	dados_module.trainees.map( ( v , index4 ) => {
																			
																		if(v.trainee_id === '')
																			return ''
																		else
																			return(

																				<tr key = {`${index4}`}>
																					<td>
																						<label className="col-form-label">{v.trainee_name}</label>
																					</td>
																					<td>
																						{
																							v.trainee_module_evaluation !== undefined && v.trainee_module_evaluation !== '' ?
																								v.trainee_module_evaluation
																							:
																								<i className={"bi bi-clipboard-x fs-4"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>

																						}
																					</td>

																				</tr>

																			)
																	})
																) : <tr>
																		<td>
																			<span className='fw-bold'>{language[lang].trainees_empty}</span>
																		</td>
																	</tr>
															}
														</tbody>
													</table>
												</div>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>

						{
							//module sessions
							is_edit === true /*&& add_trainers_permission*/ ?

								<div className="row mb-3" id="sessions">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].sessions}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">
											<div className='col-12 mt-3'>
												<h4 className="fw-bolder">{language[lang].session}</h4>
											</div>
											{ 
												dados_module.sessions !== undefined && dados_module.sessions.length > 0 ? (
														
													dados_module.sessions.map( ( elem , index ) => {

														let selectAllTrainees = ''

														if(elem.trainees !== undefined) {
															selectAllTrainees = elem.trainees.every(v => v.trainee_session_attendance)
															//console.log('Todos seleccionados: ', selectAllTrainees)
														}
														
														if(elem.name === '')
															return ''
														else
															return(
																
																<div  key = { `${index}` } className="col-12 mb-3">
																	<div className='row'>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].name}</label>
																				:
																					null
																			}
																			<div className='input-group'>
																				<input
																					type="text" 
																					className = "form-control rounded-0"  
																					name ="name"  
																					value = { elem.name }
																					data-module_id = {dados_module.id}
																					data-session_id = { index }
																					onChange={handle_change_sessions_info}
																					//readOnly
																				/>
																			</div>
																		</div>
																		<div className='col-12 col-md-2'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].module_data}</label>
																				:
																					null
																			}
																			<input
																				type="date" 
																				className = "form-control rounded-0"  
																				name ="data"  
																				value = { elem.data }
																				data-module_id = {dados_module.id}
																				data-session_id = { index }
																				onChange={handle_change_sessions_info}
																				//readOnly
																			/>
																		</div>
																		<div className='col-12 col-md-2'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].module_inicio}</label>
																				:
																					null
																			}
																			<input
																				type="time" 
																				className = "form-control rounded-0"  
																				name ="inicio"  
																				value = { elem.inicio }
																				data-module_id = {dados_module.id}
																				data-session_id = { index }
																				onChange={handle_change_sessions_info}
																				//readOnly
																			/>
																		</div>
																		<div className='col-12 col-md-2'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].module_fim}</label>
																				:
																					null
																			}
																			<input
																				type="time" 
																				className = "form-control rounded-0"  
																				name ="fim"  
																				value = { elem.fim }
																				data-module_id = {dados_module.id}
																				data-session_id = { index }
																				onChange={handle_change_sessions_info}
																				//readOnly
																			/>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].table_actions}</label>
																				:
																					null
																			}
																			<div className='position-relative'>
																				<button
																					//className="btn btn-link"
																					className='action'
																					type="button" 
																					alt={language[lang].attendance_register}
																					title={language[lang].attendance_register}
																					data-bs-toggle="offcanvas" 
																					data-bs-target={"#offcanvasAttendanceListSession_"+ index}
																					aria-controls={"offcanvasAttendanceListSession_"+ index}
																					>
																						{/*language[lang].attendance_view*/}
																						<i className="bi bi-people fs-3"></i>
																						<span className="tooltiptext">{language[lang].attendance_register}</span>
																				</button>
																				<button
																					className="action ms-3 d-none"
																					type="button" 
																					alt={language[lang].session_support_material}
																					title={language[lang].session_support_material}
																					data-bs-toggle="offcanvas" 
																					data-bs-target={"#offcanvasSessionMaterials_"+ index}
																					aria-controls={"offcanvasSessionMaterials_"+ index}
																					>
																						<i className="bi bi-files fs-3"></i>
																						<span className="tooltiptext">{language[lang].session_support_material}</span>
																				</button>
																				<button
																					className="action ms-3"
																					type="button" 
																					alt={language[lang].session_support_material}
																					title={language[lang].session_support_material}
																					data-bs-toggle="modal"
																					data-bs-target={"#sessionMaterialsModal_" + index}
																					>
																						<i className="bi bi-files fs-3"></i>
																						<span className="tooltiptext">{language[lang].session_support_material}</span>
																				</button>
																				<button
																					className="action ms-3"
																					type="button" 
																					alt={language[lang].session_evaluation}
																					title={language[lang].session_evaluation}
																					data-bs-toggle="modal"
																					data-bs-target={"#sessionEvaluationModal_" + index}
																					>
																						<i className="bi bi-file-text fs-3"></i>
																						<span className="tooltiptext">{language[lang].session_evaluation}</span>
																				</button>
																			</div>
																			<div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="true" tabIndex="-1" id={"offcanvasAttendanceListSession_"+ index} aria-labelledby={"offcanvasAttendanceListSession_" + index + "_Label"}>
																				<div className="offcanvas-header">
																					<h5 className="offcanvas-title" id={"offcanvasAttendanceListSession_" + index + "_Label"}>{elem.name}</h5>
																					<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
																				</div>
																				<div className="offcanvas-body">
																					<h6 className='fw-bold'>{language[lang].attendance_record}</h6>
																					{ 
																						elem.trainees !== undefined && elem.trainees.length > 0 ? (

																							<div className="col-12 mb-2">
																								<div className='row'>
																									<label className='col-form-label fw-bold'>{language[lang].trainees}&#58;</label>
																									<div className='col-12 col-md-8'>
																										<label className='col-form-label fw-bold d-block'>{language[lang].name}</label>
																										<span className='invisible'>
																											{language[lang].all}
																										</span>
																									</div>
																									<div className='col-12 col-md-4'>
																										<label className='col-form-label fw-bold'>{language[lang].attendance_present}</label>
																										<div>
																											<input 
																												className="form-check-input" 
																												type="checkbox" 
																												name="trainee_session_attendance"
																												title={language[lang].attendance_mark_unmark_all}
																												//id="checkboxNoLabel" 
																												data-module_id = {dados_module.id}
																												data-session_id = { index }
																												value={selectAllTrainees === true ? false : true}
																												checked={selectAllTrainees === true ? true : false}
																												onChange={handle_change_sessions_select_all_trainees}
																												aria-label={language[lang].attendance_mark_unmark_all}
																											/>
																										</div>
																									</div>
																								
																									{ 
																										elem.trainees.map( ( v , index2 ) => {
																												
																											if(v.trainee_id === '')
																												return ''
																											else
																												return(
																													<div  key = { `${index2}` } className="col-12 mb-2">
																														<div className='row'>
																															<div className='col-12 col-md-8'>
																																<label className='col-form-label fw-bold d-block d-none'>{language[lang].name}</label>
																																<span>
																																	{v.trainee_name}
																																</span>
																															</div>
																															<div className='col-12 col-md-4'>
																																<label className='col-form-label fw-bold d-none'>{language[lang].attendance_present}</label>
																																<div>
																																	<input 
																																		className="form-check-input" 
																																		type="checkbox" 
																																		name="trainee_session_attendance"
																																		//id="checkboxNoLabel" 
																																		data-module_id = {dados_module.id}
																																		data-session_id = { index }
																																		data-index = { index2 }
																																		value={v.trainee_session_attendance === true ? false : true}
																																		checked={v.trainee_session_attendance === true ? true : false}
																																		onChange={handle_change_sessions_trainees}
																																		aria-label={language[lang].attendance}
																																	/>
																																</div>
																															</div>
																														</div>
																													</div>

																													)
																											})											
																												
																										
																									}
																									<div className='col-12 mt-5'>
																										<button type="submit" form="form" className="btn btn-primary">
																											<span>{language[lang].save}</span>
																										</button>
																										<button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="offcanvas">{language[lang].close}</button>
																									</div>
																								</div>
																							</div>
																						) : <p className='fw-bold mt-4'>{language[lang].trainees_empty_2}</p>
																					}
																				</div>
																			</div>
																			<div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="true" tabIndex="-1" id={"offcanvasSessionMaterials_"+ index} aria-labelledby={"offcanvasSessionMaterials_" + index + "_Label"}>
																				<div className="offcanvas-header">
																					<h5 className="offcanvas-title" id={"offcanvasSessionMaterials_" + index + "_Label"}>{elem.name}</h5>
																					<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
																				</div>
																				<div className="offcanvas-body">
																					<h5 className='fw-bold'>{language[lang].session_support_material}</h5>

																					<div className="col-12 mb-2">
																						<label className='col-form-label fw-bold'>{language[lang].documents}&#58;</label>
																						<div className="div-form-input mb-4 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"session-input-files-pdf-"+ index}>{language[lang].doc_choose}</label>
																							<input
																								id={"session-input-files-pdf-"+ index}
																								type="file"
																								accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
																								data-order={'0'}
																								data-type={'doc'}
																								data-sessionindex={index}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerSessionsFilesDoc}
																								multiple
																							/>
																						</div>

																						{
																						treeDataSessions !== undefined && treeDataSessions[index] !== undefined && treeDataSessions[index].length > 0 ?
																							<SortableTree
																								isVirtualized={false}
																								treeData={(treeDataSessions[index] !== undefined ? treeDataSessions[index] : [] )}
																								maxDepth={1}
																								//onChange={() => console.log('onChange')}
																								onChange={treeDataSessions => handle_change_sessions_tree(treeDataSessions, index)}
																								getNodeKey={({ node }) => node.id}
																								generateNodeProps={extendedNode => ({
																									title: (
																										<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={'0'} data-id={extendedNode.node.id} data-index={index} data-link={extendedNode.node.link} onBlur={edit_element_sessions_tree} />
																									),
																									buttons: [
																										<button type="button" onClick={() => open_link(extendedNode.node.link) } className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																										<button type="button" onClick={() => console.log('clipboard')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																										<button type="button" onClick={() => remove_element_session_tree('0', extendedNode.node.id, extendedNode.node.link, index)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																									],
																								})}
																							/>
																						:
																							null
																						}

																					</div>

																					<div className='col-12 mb-3'>
																						<h6 className='fw-bold'>Links</h6>
																						<label className='col-form-label fw-bold'>{language[lang].link_insert}&#58;</label>
																						<div className='input-group'>
																							<input
																								type="text" 
																								className = "form-control rounded-0"  
																								name ="support_material_links"  
																								value = { inputLink !== '' ? inputLink : ''}
																								data-module_id = {dados_module.id}
																								data-session_id = { index }
																								onChange={handle_change_sessions_info}
																								//readOnly
																							/>
																							<div className='input-group-text p-0'>
																								<button
																									type="button" 
																									alt={language[lang].add_link}
																									title={language[lang].add_link}
																									onClick = {() => addMaterialInputLink(dados_module.id, index, 'support_material_links') }
																									>
																										<i className="bi bi-plus fs-4 px-2"></i>
																								</button>
																							</div>
																						</div>
																					</div>

																					{ 
																						elem.support_material_links !== undefined && elem.support_material_links.length > 0 ? (
																							<div className='col-12 mb-3'>
																								<label className='col-form-label fw-bold'>{language[lang].links_list}&#58;</label>
																								<ul className='list-group'>
																									{
																										elem.support_material_links.map( ( v , index2 ) => {

																											//check if link has http (if not, add it to link)
																											if(v.link !== undefined && v.link !== '' && v.link.substr(0, 4) !== 'http') {
																												v.link = 'http://' + v.link;
																												//console.log(v.link)
																			
																											}
																										
																											if(v.link === '')
																												return ''
																											else
																												return(
																													<div key = { `${index2}` } className='d-inline-flex align-items-center mb-2'>
																														<a href={v.link} alt={language[lang].link_open} title={language[lang].link_open} className='text-break' target='_blank' rel="noreferrer">
																															{v.link}
																														</a>
																														<button type="button" onClick={() => removeMaterialInputLink(dados_module.id, index, index2, 'support_material_links')} alt={language[lang].remove} title={language[lang].remove}>
																															<i className="bi bi-x fs-4 ps-2"></i>
																														</button>
																													</div>
																													
																												)
																										})
																									}
																								</ul>
																							</div>

																						) : <span className='fw-bold'>{language[lang].links_empty}</span>
																					}

																					<div className='col-12 mt-5'>
																						<button type="submit" form="form" className="btn btn-primary">
																							<span>{language[lang].save}</span>
																						</button>
																						<button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="offcanvas">{language[lang].close}</button>
																					</div>
																				</div>
																			</div>
																			<div className={"modal bg-light fade"} id={"sessionMaterialsModal_" + index} tabIndex="-1" aria-labelledby={"sessionMaterialsModalLabel_" + index} aria-hidden="true" >
																				<div className="modal-dialog modal-dialog-centered">
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title" id={"sessionMaterialsModalLabel_" + index}>
																								{elem.name}
																							</h5>
																							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																						</div>
																						<div className="modal-body">
																							<h5 className='fw-bold'>{language[lang].session_support_material}</h5>

																							<div className="col-12 mb-2">
																								<label className='col-form-label fw-bold'>{language[lang].documents}&#58;</label>
																								<div className="div-form-input mb-4 custom-file">
																									<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"session-input-files-pdf-" + index}>{language[lang].doc_choose}</label>
																									<input
																										id={"session-input-files-pdf-" + index}
																										type="file"
																										accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
																										data-order={'0'}
																										data-type={'doc'}
																										data-sessionindex={index}
																										className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																										onChange={onChangeHandlerSessionsFilesDoc}
																										multiple
																									/>
																								</div>

																								{/*console.log('Tree Data sessions Materials', treeDataSessions[index])*/}

																								{
																								treeDataSessions !== undefined && treeDataSessions[index] !== undefined && treeDataSessions[index].length > 0 ?
																									<SortableTree
																										isVirtualized={false}
																										treeData={(treeDataSessions[index] !== undefined ? treeDataSessions[index] : [] )}
																										maxDepth={1}
																										//onChange={() => console.log('onChange')}
																										onChange={treeDataSessions => handle_change_sessions_tree(treeDataSessions, index)}
																										getNodeKey={({ node }) => node.id}
																										generateNodeProps={extendedNode => ({
																											title: (
																												<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={'0'} data-id={extendedNode.node.id} data-index={index} data-link={extendedNode.node.link} onBlur={edit_element_sessions_tree} />
																											),
																											buttons: [
																												<button type="button" onClick={() => open_link(extendedNode.node.link) } className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																												<button type="button" onClick={() => console.log('clipboard')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																												<button type="button" onClick={() => remove_element_session_tree('0', extendedNode.node.id, extendedNode.node.link, index)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																											],
																										})}
																									/>
																								:
																									null
																								}

																							</div>

																							<div className='col-12 mb-3'>
																								<h6 className='fw-bold'>Links</h6>
																								<label className='col-form-label fw-bold'>{language[lang].link_insert}&#58;</label>
																								<div className='input-group'>
																									<input
																										type="text" 
																										className = "form-control rounded-0"  
																										name ="support_material_links"  
																										value = { inputLink !== '' ? inputLink : ''}
																										data-module_id = {dados_module.id}
																										data-session_id = { index }
																										onChange={handle_change_sessions_info}
																										//readOnly
																									/>
																									<div className='input-group-text p-0'>
																										<button
																											type="button" 
																											alt={language[lang].add_link}
																											title={language[lang].add_link}
																											onClick = {() => addMaterialInputLink(dados_module.id, index, 'support_material_links') }
																											>
																												<i className="bi bi-plus fs-4 px-2"></i>
																										</button>
																									</div>
																								</div>
																							</div>

																							{ 
																								elem.support_material_links !== undefined && elem.support_material_links.length > 0 ? (
																									<div className='col-12 mb-3'>
																										<label className='col-form-label fw-bold'>{language[lang].links_list}&#58;</label>
																										<ul className='list-group'>
																											{
																												elem.support_material_links.map( ( v , index2 ) => {

																													//check if link has http (if not, add it to link)
																													if(v.link !== undefined && v.link !== '' && v.link.substr(0, 4) !== 'http') {
																														v.link = 'http://' + v.link;
																														//console.log(v.link)
																					
																													}
																												
																													if(v.link === '')
																														return ''
																													else
																														return(
																															<div key = { `${index2}` } className='d-inline-flex align-items-center mb-2'>
																																<a href={v.link} alt={language[lang].link_open} title={language[lang].link_open} className='text-break' target='_blank' rel="noreferrer">
																																	{v.link}
																																</a>
																																<button type="button" onClick={() => removeMaterialInputLink(dados_module.id, index, index2, 'support_material_links')} alt={language[lang].remove} title={language[lang].remove}>
																																	<i className="bi bi-x fs-4 ps-2"></i>
																																</button>
																															</div>
																															
																														)
																												})
																											}
																										</ul>
																									</div>

																								) : <span className='fw-bold'>{language[lang].links_empty}</span>
																							}
																						</div>
																						<div className="modal-footer">
																							<button type="submit" form="form" className="btn btn-primary">
																								<span>{language[lang].save}</span>
																							</button>
																							<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{language[lang].close}</button>
																						</div>
																					</div>
																				</div>
																			</div>
																			<div className={"modal bg-light fade"} id={"sessionEvaluationModal_" + index} tabIndex="-1" aria-labelledby={"sessionEvaluationModalLabel_" + index} aria-hidden="true" >
																				<div className="modal-dialog modal-dialog-centered">
																					<div className="modal-content">
																						<div className="modal-header">
																							<h5 className="modal-title" id={"sessionEvaluationModalLabel_" + index}>
																								{elem.name}
																							</h5>
																							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																						</div>
																						<div className="modal-body">
																							<h5 className='fw-bold'>{language[lang].session_evaluation}</h5>

																							<div className="col-12 mb-2">
																								<label className='col-form-label fw-bold'>{language[lang].documents}&#58;</label>
																								<div className="div-form-input mb-4 custom-file">
																									<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"session-input-files-evaluation-"+ index}>{language[lang].doc_choose}</label>
																									<input
																										id={"session-input-files-evaluation-"+ index}
																										type="file"
																										accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
																										data-order={'0'}
																										//data-number={index}
																										data-type={'evaluation'}
																										data-sessionindex={index}
																										className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																										onChange={onChangeHandlerSessionsFilesDoc}
																										multiple
																									/>
																								</div>

																								{/*console.log('Tree Data sessions Evaluation', treeDataSessionsEvaluation[index])*/}

																								{
																								treeDataSessionsEvaluation !== undefined && treeDataSessionsEvaluation[index] !== undefined && treeDataSessionsEvaluation[index].length > 0 ?
																									<SortableTree
																										isVirtualized={false}
																										treeData={(treeDataSessionsEvaluation[index] !== undefined ? treeDataSessionsEvaluation[index] : [] )}
																										maxDepth={1}
																										//onChange={() => console.log('onChange')}
																										onChange={treeDataSessionsEvaluation => handle_change_sessions_evaluation_tree(treeDataSessionsEvaluation, index)}
																										getNodeKey={({ node }) => node.id}
																										generateNodeProps={extendedNode => ({
																											title: (
																												<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={'0'} data-id={extendedNode.node.id} data-link={extendedNode.node.link} data-index={index} onBlur={edit_element_sessions_evaluation_tree} />
																											),
																											buttons: [
																												<button type="button" onClick={() => open_link(extendedNode.node.link) } className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																												<button type="button" onClick={() => console.log('clipboard')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																												<button type="button" onClick={() => remove_element_session_evaluation_tree('0', extendedNode.node.id, extendedNode.node.link, index)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																											],
																										})}
																									/>
																								:
																									null
																								}

																								{
																									/*files_session_evaluation_name !== undefined && files_session_evaluation_name[index] !== undefined && files_session_evaluation_name.length > 0 ?
																										<p className='mt-3'>
																											<i className="bi bi-bookmark me-2"></i>
																											{files_session_evaluation_name[index].name}
																										</p>
																									:
																										elem.evaluations_material !== undefined && elem.evaluations_material[index] !== undefined && elem.evaluations_material[index] !== null ?
																											<p className='mt-3'>
																												<i className="bi bi-bookmark me-2"></i>
																												<a href={elem.evaluations_material[index].link} alt="" target='_blank' rel="noreferrer">{elem.evaluations_material[index].name}</a>
																											</p>
																										:
																											null*/
																								}

																							</div>

																							<div className='col-12 mb-3'>
																								<h6 className='fw-bold'>Links</h6>
																								<label className='col-form-label fw-bold'>{language[lang].link_insert}&#58;</label>
																								<div className='input-group'>
																									<input
																										type="text" 
																										className = "form-control rounded-0"  
																										name ="evaluations_material_links"  
																										value = { inputLink !== '' ? inputLink : ''}
																										data-module_id = {dados_module.id}
																										data-session_id = { index }
																										onChange={handle_change_sessions_info}
																										//readOnly
																									/>
																									<div className='input-group-text p-0'>
																										<button
																											type="button" 
																											alt={language[lang].add_link}
																											title={language[lang].add_link}
																											onClick = {() => addMaterialInputLink(dados_module.id, index, 'evaluations_material_links') }
																											>
																												<i className="bi bi-plus fs-4 px-2"></i>
																										</button>
																									</div>
																								</div>
																							</div>

																							{ 
																								elem.evaluations_material_links !== undefined && elem.evaluations_material_links.length > 0 ? (
																									<div className='col-12 mb-3'>
																										<label className='col-form-label fw-bold'>{language[lang].links_list}&#58;</label>
																										<ul className='list-group'>
																											{
																												elem.evaluations_material_links.map( ( v , index2 ) => {

																													//check if link has http (if not, add it to link)
																													if(v.link !== undefined && v.link !== '' && v.link.substr(0, 4) !== 'http') {
																														v.link = 'http://' + v.link;
																														//console.log(v.link)
																					
																													}
																												
																													if(v.link === '')
																														return ''
																													else
																														return(
																															<div key = { `${index2}` } className='d-inline-flex align-items-center mb-2'>
																																<a href={v.link} alt={language[lang].link_open} title={language[lang].link_open} className='text-break' target='_blank' rel="noreferrer">
																																	{v.link}
																																</a>
																																<button type="button" onClick={() => removeMaterialInputLink(dados_module.id, index, index2, 'evaluations_material_links')} alt={language[lang].remove} title={language[lang].remove}>
																																	<i className="bi bi-x fs-4 ps-2"></i>
																																</button>
																															</div>
																															
																														)
																												})
																											}
																										</ul>
																									</div>

																								) : <span className='fw-bold'>{language[lang].links_empty}</span>
																							}
																						</div>
																						<div className="modal-footer">
																							<button type="submit" form="form" className="btn btn-primary">
																								<span>{language[lang].save}</span>
																							</button>
																							<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{language[lang].close}</button>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		{/*<div className='col-12 col-md-3'>
																			<label className='col-form-label fw-bold'>{language[lang].final_evaluation}</label>
																			<input
																				type="text" 
																				className = "form-control rounded-0"  
																				name ="trainee_module_evaluation"  
																				data-module_id = {dados_module.id}
																				data-index = { index }
																				value = { elem.trainee_module_evaluation !== undefined ? elem.trainee_module_evaluation : '' }
																				onChange={handle_change_module_trainees}
																			/>
																		</div>*/}
																		{/*<div className='col-12 col-md-3'>
																			<label className='col-form-label fw-bold d-block invisible'>{language[lang].table_actions}</label>
																			<button type="button" onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-warning"} >
																				<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																			</button>
																			<button type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeInputCandidate(index) }>
																				<img src ="./img/adicionar.svg" alt={language[lang].candidate_remove} title={language[lang].candidate_remove} />
																			</button>
																		</div>*/}
																	</div>
																	
																</div>
																
															)
													})											
														
												) : <span className='fw-bold'>{language[lang].sessions_empty}</span>
											}
										</div>

									</div>



									<div className='col-12'>

										<div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="true" tabIndex="-1" id={"offcanvasAttendanceListMessage"} aria-labelledby={"offcanvasAttendanceListMessage_Label"}>
											<div className="offcanvas-header">
												<h5 className="offcanvas-title" id={"offcanvasAttendanceListMessage_Label"}>{language[lang].messages}</h5>
												<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
											</div>
											<div className="offcanvas-body">
												<h6 className='fw-bold'>{language[lang].send_title}</h6>
												{ 
												dados_module.trainees !== undefined && dados_module.trainees.length > 0 ? 
													<>
														<div className="col-12 mb-2">
															<div className='row'>
																<label className='col-form-label fw-bold'>{language[lang].trainees}&#58;</label>
																<div className='col-12 col-md-8'>
																	<label className='col-form-label fw-bold d-block'>{language[lang].name}</label>
																	<span className='invisible'>
																		{language[lang].all}
																	</span>
																</div>
																<div className='col-12 col-md-4'>
																	<label className='col-form-label fw-bold'>{language[lang].send}</label>
																</div>
																{ 
																	dados_module.trainees.map( ( v , index2 ) => {
																			
																		if(v.trainee_id === '')
																			return ''
																		else
																			return(
																				<div  key = { `${index2}` } className="col-12 mb-2">
																					<div className='row'>
																						<div className='col-12 col-md-8'>
																							<label className='col-form-label fw-bold d-block d-none'>{language[lang].name}</label>
																							<span>
																								{v.trainee_name}
																							</span>
																						</div>
																						<div className='col-12 col-md-4'>
																							<label className='col-form-label fw-bold d-none'>{language[lang].attendance_present}</label>
																							<div>
																								<input 
																									className="form-check-input" 
																									type="checkbox" 
																									name="trainee_session_attendance"
																									//id="checkboxNoLabel" 
																									data-module_id = {dados_module.id}
																									data-session_id = { '0' }
																									data-index = { index2 }
																									data-traineeid={v.trainee_id}
																									data-traineename={v.trainee_name}
																									value={a_trainees_send.filter((e) => e.id === v.trainee_id).length > 0 ? false : true}
																									checked={a_trainees_send.filter((e) => e.id === v.trainee_id).length > 0 ? true : false}
																									onChange={handle_change_send_trainees}
																									aria-label={language[lang].attendance}
																								/>
																							</div>
																						</div>
																					</div>
																				</div>

																			)
																	})	
																			
																	
																}
																<div className='col-12 mt-5'>
																	<button 
																		type="button"
																		className="btn btn-primary"
																		data-bs-toggle="modal" 
																		data-bs-target={"#send_modal"}
																		onClick={() => sendMessageModal(dados.current.info.name, dados_module.name)}
																		title={language[lang].send}
																	>
																		{language[lang].send_title}
																		<i className="bi bi-send text-white ms-2"></i>
																	</button>
																	<button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="offcanvas">{language[lang].close}</button>
																</div>



																<div className="modal bg-light fade" tabIndex="-1" id={"send_modal"}>
																	<div className="modal-dialog modal-dialog-centered">
																		<div className="modal-content">
																			<div className="modal-header">
																				<h5 className="modal-title">{language[lang].messages_new}</h5>
																				<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
																					<i className="bi bi-x fs-2"></i>
																				</div>
																			</div>

																			<div className="modal-body">
																				<div className="row">
																					<div className="col-12">
																						<label className="col-form-label fw-bold fs-6 me-2">{language[lang].field_to}: </label>
																						{modal_entity_to_name}
																					</div>
																				</div>

																				<div className="row">
																					<div className="col-12">
																						<label className="col-form-label fw-bold fs-6">{language[lang].field_subject}</label>
																						<input type="text" className="form-control mb-3" name="subject" value={modal_subject} placeholder={language[lang].field_subject_placeholder} onChange={(e) => set_modal_subject(e.target.value)}  />
																					</div>
																				</div>

																				<div className="row">
																					<div className="col-12">
																						<label className="col-form-label fw-bold fs-6">{language[lang].field_message}</label>
																						<textarea type="text" className="form-control mb-3" name="subject" value={modal_message} placeholder={language[lang].field_subject_placeholder} onChange={(e) => set_modal_message(e.target.value)}  />
																					</div>
																				</div>
																			</div>

																			<div className="modal-footer">
																				<button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
																				<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSendMessage}>{language[lang].send}</button>
																			</div>
																		</div>
																	</div>
																</div> 
															</div>
														</div>
													</>
												
												: 
													<p className='fw-bold mt-4'>{language[lang].trainees_empty_3}</p>
												}
											</div>
										</div>



									</div>
								</div>
							: ''
						}

						{
							//formation trainees
							is_edit === true /*&& add_trainers_permission*/ ?

								<div className="row mb-3" id="trainees">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].trainees}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">
											<div className='col-12 mt-3'>
												<h4 className="fw-bolder">{language[lang].trainee}</h4>
											</div>
											{ 
												dados_module.trainees !== undefined && dados_module.trainees.length > 0 ? (
														
													dados_module.trainees.map( ( elem , index ) => {

														//console.log(elem)
														
														if(elem.trainee_name === '')
															return ''
														else
															return(
																
																<div  key = { `${index}` } className="col-12 mb-3">
																	<div className='row'>
																		<div className='col-12 col-md-1 d-none'>
																			<label className='col-form-label fw-bold invisible'>{language[lang].profile}</label>
																			<div>
																				<Link 
																					className="btn btn-link"
																					to={{ 
																						pathname: '/trainee_view',
																						state: {
																							item: {id: elem.trainee_id},
																							operation: 'view',
																							backup_operation: 'profile_view',
																							formation_id: dados.current.id
																						},
																					}} >
																					<span>{language[lang].profile_view}</span>
																				</Link>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].name}</label>
																				:
																					null
																			}
																			<div className='input-group'>
																				<div className='input-group-text p-0'>
																					<Link
																						title={language[lang].profile_view}
																						alt={language[lang].profile_view}
																						to={{ 
																							pathname: '/trainee_view',
																							state: {
																								item: {id: elem.trainee_id},
																								operation: 'view',
																								backup_operation: 'profile_view',
																								formation_id: dados.current.id,
																								module_id: dados_module.id
																							},
																						}} >
																						<i className="bi bi-person-fill fs-4 px-2 text-primary"></i>
																					</Link>
																				</div>
																				<input
																					type="text" 
																					className = "form-control rounded-0"  
																					name ="trainee_name"  
																					value = { elem.trainee_name }
																					readOnly
																				/>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>Email</label>
																				:
																					null
																			}
																			<input
																				type="text" 
																				className = "form-control rounded-0"  
																				name ="trainee_email"  
																				value = { elem.trainee_email }
																				readOnly
																			/>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].final_evaluation}</label>
																				:
																					null
																			}
																			<input
																				type="text" 
																				className = "form-control rounded-0"  
																				name ="trainee_module_evaluation"  
																				data-module_id = {dados_module.id}
																				data-index = { index }
																				value = { elem.trainee_module_evaluation !== undefined ? elem.trainee_module_evaluation : '' }
																				onChange={handle_change_module_trainees}
																			/>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].files}</label>
																				:
																					null
																			}
																			<div>
																				<button
																					className="btn btn-link"
																					type="button" 
																					data-bs-toggle="offcanvas" 
																					data-bs-target={"#offcanvasFileListTrainee_"+ index}
																					aria-controls={"offcanvasFileListTrainee_"+ index}
																					>
																						{language[lang].files_view}
																				</button>
																			</div>
																			<div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="true" tabIndex="-1" id={"offcanvasFileListTrainee_"+ index} aria-labelledby={"offcanvasFileListTrainee_" + index + "_Label"}>
																				<div className="offcanvas-header">
																					<h5 className="offcanvas-title" id={"offcanvasFileListTrainee_" + index + "_Label"}>{elem.trainee_name}</h5>
																					<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
																				</div>
																				<div className="offcanvas-body">
																					{ 
																						elem.files !== undefined && elem.files.length > 0 ? (
																
																							<div className='mb-4 tasks'>
																								<h4 className='fw-bold'>{language[lang].tasks_module}</h4>
																								<label className='col-form-label fw-bold'>{language[lang].files}</label>

																								{
																									elem.files.map( ( v , index2 ) => {
																										
																										if(v.link === '')
																											return ''
																										else
																											return(
																												<div  key = { `${index2}` } className="col-12 mb-2">
																													<div className='row'>
																														<div className='col-12'>
																															<label className='col-form-label fw-bold d-none'>{language[lang].files}</label>
																															<i className="bi bi-bookmark me-2"></i>
																															<a href={v.link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
																																{v.name}
																															</a>
																														</div>
																													</div>
																												</div>

																											)
																									})
																								}
																							</div>											
																								
																						) : 
																							<div className='mb-4 tasks'>
																								<h4 className='fw-bold'>{language[lang].tasks_module}</h4>
																								<span className='fw-bold'>{language[lang].tasks_files_empty}</span>
																							</div>
																					}
																					<div className='mb-4 evaluations d-none'>
																						<h4 className='fw-bold'>{language[lang].module_evaluations}</h4>
																						{ 
																							elem.evaluation_files !== undefined && elem.evaluation_files.length > 0 ? (
																								
																								elem.evaluation_files.map( ( v , index2 ) => {
																									
																									if(v.link === '')
																										return ''
																									else
																										return(
																											<div  key = { `${index2}` } className="col-12 mb-2">
																												<div className='row'>
																													<div className='col-12 col-md-7'>
																														<label className='col-form-label fw-bold d-block'>{language[lang].evaluation + ' ' + (index2 + 1) }</label>
																														<i className="bi bi-bookmark me-2"></i>
																														<a href={v.link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
																															{v.name}
																														</a>
																													</div>
																													<div className='col-12 col-md-5'>
																														<label className='col-form-label fw-bold'>{language[lang].evaluation}</label>
																														<input
																															type="text" 
																															className = "form-control rounded-0"  
																															name ="evaluation"  
																															data-module_id = {dados_module.id}
																															data-trainee_index = { index }
																															data-file_index = { index2 }
																															value = { v.evaluation !== undefined ? v.evaluation : '' }
																															onChange={handle_change_module_trainees_evaluations}
																														/>
																													</div>
																												</div>
																											</div>

																											)
																									})											
																									
																							) : <span className='fw-bold'>{language[lang].module_evaluations_files_empty}</span>
																						}
																					</div>

																					<div className='col-12 sessions-tasks'>
																						<h4 className='fw-bold'>{language[lang].tasks_session}</h4>

																						{ 
																							dados_module.sessions !== undefined && dados_module.sessions.length > 0 ? (

																								<div className="accordion border-0 mb-5" id="accordionSession"> 

																									{
																										dados_module.sessions.map( ( elem2 , k ) => {

																											return(
																													<div key={k}>
                                                                
																														<div className="accordion-item mt-3">

																															<div className="accordion-header" id={'trainee-'+ index + '-heading-' + k}>
																																<button className={"accordion-button collapsed"} type="button" data-bs-toggle="collapse" data-bs-target={'#trainee-'+ index + '-collapse-' + k} aria-expanded="true" aria-controls={'trainee-'+ index + '-collapse-' + k}>
																																	<span>{elem2.name}</span>
																																</button>
																															</div>
																															<div id={'trainee-'+ index + '-collapse-' + k} className={"accordion-collapse collapse"} aria-labelledby={'trainee-'+ index + '-heading-' + k} data-bs-parent="#accordionSession">
																																<div className="accordion-body">

																																	{ 

																																		elem2.trainees !== undefined && elem2.trainees.length > 0 ? (

																																			elem2.trainees.map( ( elem3 , index3 ) => {

																																				if(parseInt(elem3.trainee_id) === parseInt(elem.trainee_id)){

																																					return (

																																						<div key = { `${index3}` }>
																																							{

																																								elem3.files !== undefined && elem3.files.length > 0 ? (
																																									<div>
																																								
																																										<label className='col-form-label fw-bold'>{language[lang].files}</label>
																																										{

																																											elem3.files.map( ( v , f_index ) => {

																																												//console.log(v)
																																	
																																												if(v.link === '')
																																													return ''
																																												else
																																													return( 

																																														<div  key = { `${f_index}` } className="col-12 mb-2">
																																															<div className='row'>
																																																<div className='col-12'>
																																																	<i className="bi bi-bookmark me-2"></i>
																																																	<a href={v.link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
																																																		{v.name}
																																																	</a>
																																																</div>
																																															</div>
																																														</div>
																																														
																																													)
																																											})
																																										}
																																									</div>

																																								) : <span className='fw-bold'>{language[lang].tasks_files_empty}</span>
																																							}
																																							
																																						</div>
																																					)
																																				} else return null

																																			})

																																		) : null
																																	}

																																</div>
																															</div>
																														</div>
																													
																													</div>
																												
																											)

																										})
																									}
																								</div>


																							) : <span className='fw-bold'>{language[lang].sessions_empty}</span>
																						}
																						
																					</div>
																					<div className='col-12 mt-5'>
																						<button type="submit" form="form" className="btn btn-primary d-none">
																							<span>{language[lang].save}</span>
																						</button>
																						<button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="offcanvas">{language[lang].close}</button>
																					</div>
																				</div>
																			</div>
																		</div>
																		{/*<div className='col-12 col-md-3'>
																			<label className='col-form-label fw-bold d-block invisible'>{language[lang].table_actions}</label>
																			<button type="button" onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-warning"} >
																				<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																			</button>
																			<button type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeInputCandidate(index) }>
																				<img src ="./img/adicionar.svg" alt={language[lang].candidate_remove} title={language[lang].candidate_remove} />
																			</button>
																		</div>*/}
																	</div>
																	
																</div>
																
															)
													})											
														
												) : <span className='fw-bold'>{language[lang].trainees_empty}</span>
											}
										</div>

									</div>
								</div>
							: ''
						}

						{
							is_edit === true /*&& add_trainers_permission*/ ?
								<div className='row mb-3' id="support_material">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].module_support_material}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">
											<div className='col-12 mt-3'>
												<h4 className="fw-bolder">{language[lang].documents}</h4>
											</div>

											<div className='div-files col-12 col-sm-6 mt-3'>
												<div className="div-form-input col-12 mb-4 custom-file">
													<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-0"}>{language[lang].doc_choose}</label>
													<input
														id={"input-files-pdf-0"}
														type="file"
														accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
														data-order={'0'}
														data-type={'doc'}
														className="dropzone-select btn btn-sm btn-primary me-2 d-none"
														onChange={onChangeHandlerFilesDoc}
														multiple
													/>
												</div>

												{
												treeData !== undefined && treeData.length > 0 ?
													<SortableTree
														isVirtualized={false}
														treeData={treeData}
														maxDepth={1}
														//onChange={() => console.log('onChange')}
														onChange={treeData => handle_change_tree(treeData)}
														getNodeKey={({ node }) => node.id}
														generateNodeProps={extendedNode => ({
															title: (
																<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={'0'} data-id={extendedNode.node.id} data-link={extendedNode.node.link} onBlur={edit_element_tree} />
															),
															buttons: [
																<button type="button" onClick={() => open_link(extendedNode.node.link) } className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																<button type="button" onClick={() => console.log('clipboard')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																<button type="button" onClick={() => remove_element_tree('0', extendedNode.node.id, extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
															],
														})}
													/>
												:
													null
												}
											</div>

											<div className='div-files col-12 col-sm-6 mt-3 d-none'>
												{
												dados_module.evaluations_number !== undefined ?
													Array.from(Array(parseInt(dados_module.evaluations_number)), (_, k_en) => {

														return (
															<div key={k_en} className="mb-4">
																<h3>{language[lang].evaluation} {k_en + 1}</h3>
																<div className="div-form-input col-12 mb-2 custom-file">
																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-en-" + k_en}>{language[lang].doc_choose}</label>
																	<input
																		id={"input-files-en-" + k_en}
																		type="file"
																		accept=".pdf,.doc,.docx"
																		data-order={'0'}
																		data-number={k_en}
																		data-type={'evaluation'}
																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																		onChange={onChangeHandlerFilesDoc}
																	/>
																</div>

																{
																files_evaluation_name !== undefined && files_evaluation_name[k_en] !== undefined ?
																	<p className=' mt-3'>
																		<i className="bi bi-bookmark me-2"></i>
																		{files_evaluation_name[k_en].name}
																	</p>
																:
																	dados_module.evaluations_material !== undefined && dados_module.evaluations_material[k_en] !== undefined && dados_module.evaluations_material[k_en] !== null ?
																		<p className=' mt-3'>
																			<i className="bi bi-bookmark me-2"></i>
																			<a href={dados_module.evaluations_material[k_en].link} alt="" target='_blank' rel="noreferrer">{dados_module.evaluations_material[k_en].name}</a>
																		</p>
																	:
																		null
																}
														</div>
														)
													})
												:
													null
												}
											</div>
										</div>
									</div>
								</div>
							:
								null
						}
					</div>



				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{
									props.location.state.go_back_operation !== undefined && props.location.state.go_back_operation === 'main_view' ? (
										<li className="nav-item">
											<Link className="nav-link btn-cancel" to={{ pathname: Main.view.endpoint}}  >
												<img alt='' src={'./img/seta_2.svg'} />
												<span>{language[lang].back}</span>
											</Link>
										</li>
									) :
										<li className="nav-item">
											<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
												{/*<img alt='' src={'./img/cancelar.svg'} />
												<span>{language[lang].cancel}</span>*/}
												<img alt={language[lang].back} src={'./img/seta_2.svg'} />
												<span>{language[lang].back}</span>
											</Link>
										</li>
								}
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
